import React from 'react';
import { Col, Row } from 'react-bootstrap';
import ControlsPageSize from 'views/learning/components/ControlsPageSize';
import ControlsAdd from '../assessment/components/ControlsAdd';
import ControlsEdit from '../assessment/components/ControlsEdit';
import ControlsDelete from '../assessment/components/ControlsDelete';
import ControlsSearch from 'views/learning/components/ControlsSearch';
import ModalAddAssessment from '../assessment/components/ModalAddAssessment';
import ModalEditAssessment from '../assessment/components/ModalEditAssessment';
import Table from '../assessment/components/Table';
import TablePagination from '../assessment/components/TablePagination';
import ControlsView from '../assessment/components/ControlsView';
import ModalViewAssessment from '../assessment/components/ModalViewAssessment';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import CsLineIcons from 'cs-line-icons/CsLineIcons';
// import questionsFile
import ModalAddExam from '../assessment/ModelAddExam';
import ModalEditExam from '../assessment/ModelEditExam';
import ModalViewExam from '../assessment/ModelViewExam';
import ModalAddHomeWork from './ModelAddHomework';
import ModelEditHomeWork from './modelEditHomework';
import ModelViewHomeWork from './homeworkView';
import ControlsPageSizeComponent from 'views/learning/components/newControlPageSize';



const HomeworkTable = ({ tableInstance }) => {
  const { isOpen, whichModal,filters } = tableInstance;
   const { standardId, subjectId, seriesId, lessonId, sectionId } = filters;

  return (
    <Row>
      <Col>
        <div>
          <Row className="mb-3">
            <Col sm="12" md="5" lg="3" xxl="2">
              <div className="d-inline-block float-md-start me-1 mb-1 mb-md-0 search-input-container w-100 shadow bg-foreground">
                <ControlsSearch tableInstance={tableInstance} />
              </div>
            </Col>
            <Col sm="12" md="7" lg="9" xxl="10" className="text-end">
              <div className="d-inline-block me-0 me-sm-3 float-start float-md-none">
                     
              {/* <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top-add">Download Sample File</Tooltip>}>
      <a href={questionsFile} download="questions.xlsx">
        <Button
          style={{ marginRight: '5px' }}
          variant="foreground-alternate"
          className="btn-icon btn-icon-only shadow add-datatable"
        >
          <CsLineIcons icon="download" />
        </Button>
      </a>
    </OverlayTrigger> */}
                {(standardId && subjectId && seriesId && lessonId && sectionId) && <ControlsAdd tableInstance={tableInstance} />}{' '}
                <ControlsEdit tableInstance={tableInstance} />{' '}
                <ControlsView tableInstance={tableInstance} />{' '}
                <ControlsDelete tableInstance={tableInstance} />
              </div>
              <div className="d-inline-block">
                <ControlsPageSizeComponent tableInstance={tableInstance} />
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs="12">
              <Table className="react-table rows" tableInstance={tableInstance} />
            </Col>
            <Col xs="12">
              <TablePagination tableInstance={tableInstance} />
            </Col>
          </Row>
        </div>
        {isOpen && whichModal === 'add' && <ModalAddHomeWork tableInstance={tableInstance} />}
        {isOpen && whichModal === 'edit' && <ModelEditHomeWork tableInstance={tableInstance} />}
        {isOpen && whichModal === 'view' && <ModelViewHomeWork tableInstance={tableInstance} />}
      </Col>
    </Row>
  );
};

export default HomeworkTable;
